<template>
    <div>
        <div class="base-form-div">
            <el-form size="mini" :rules="rules" :model="ruleForm" label-width="100px" ref="ruleForm_first">
                <el-form-item label="相机位置" prop="lon">
                    <el-input v-model="ruleForm.lon">
                        <el-button @click="change_cameraPosition" slot="append">图上拾取</el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="视点位置" prop="lon">
                    <el-input v-model="ruleForm.lon">
                        <el-button @click="change_position" slot="append">图上拾取</el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="水平张角" prop="lat">
                    <el-slider @change="change_fov" v-model="ruleForm.fov"></el-slider>
                </el-form-item>
                <el-form-item label="垂直张角" prop="alt">
                    <el-slider :step="0.1" :max="1" :min="0" @change="change_aspect" v-model="ruleForm.aspect"></el-slider>
                </el-form-item>
                <!-- <el-form-item label="投射距离" prop="alt">
                    <el-slider v-model="ruleForm.ooo"></el-slider>
                </el-form-item> -->
                <el-form-item label="四周方向" prop="alt">
                    <el-slider :step="0.1" :max="360" :min="0" @change="change_heading"
                        v-model="ruleForm.heading"></el-slider>
                </el-form-item>
                <el-form-item label="俯仰角度" prop="alt">
                    <el-slider v-model="ruleForm.ooo"></el-slider>
                </el-form-item>
                <el-form-item label="透明度" prop="alt">
                    <el-slider :step="0.1" :max="1" :min="0" @change="change_alpha" v-model="ruleForm.alpha"></el-slider>
                </el-form-item>
                <el-form-item label="视锥线框">
                    <el-switch v-model="ruleForm.clamp">
                    </el-switch>
                </el-form-item>
                <el-form-item label="视频镜像">
                    <el-switch v-model="ruleForm.clamp">
                    </el-switch>
                </el-form-item>
            </el-form>
        </div>
        <div class="form-bottom">
            <el-button class="base-button" size="mini" type="primary" @click="videoPlay">播放</el-button>
            <el-button class="base-button" size="mini" type="primary" @click="locate">返回视点</el-button>
        </div>
    </div>
</template>

<script>
import { video3D, ratateDirection } from "@/utils/cesiumBD/video/video3D.js";
import LeftPick from "@/utils/cesiumBD/pick/LeftPick.js"
import { cartesian2lonlat } from "@/utils/cesiumBD/utils/CoordinateUtil.js"
let pickUti = undefined;
let selectedView = undefined;
export default {
    data() {

        function validateNumberFun(text) {
            var validateNumber = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入' + text));
                } else {
                    if (isNaN(value)) {
                        callback(new Error(text + '必须为数值,不能是其他字符'));
                    }
                    callback();
                }
            };

            return validateNumber;
        }

        return {
            ruleForm: {
                lon: "",
                lat: "",
                alt: "",
                lon_d: "",
                lon_f: "",
                lon_m: "",
                lat_d: "",
                lat_f: "",
                lat_m: "",
                clamp: true,
                radio: "3",
                x: "",
                y: ""
            },
            rules: {

            },
            cameraPosition: [106.88522877698416, 27.647903157429123, 1600],
            debugFrustum: true,
            alpha: 1,
            step: 0.05,
            position: [106.88523680329423, 27.647704251749182, 828],
            videoUrl: "http://192.168.1.139:1234data/lukou.mp4",
            fov: 1,
            aspect: 1,
        };
    },

    mounted() {

        //不加无法投射到地形上
        viewer.scene.globe.depthTestAgainstTerrain = true;

        pickUti = new LeftPick();

        this.test();
    },

    methods: {
        locate() {
            selectedView && selectedView.locate();
        },
        videoPlay() {

        },
        test() {
            var cartesian = Cesium.Cartesian3.fromDegrees(this.position[0], this.position[1], this.position[2]);
            var cameraPosition = Cesium.Cartesian3.fromDegrees(this.cameraPosition[0], this.cameraPosition[1], this.cameraPosition[2]);
            var params = {
                "type": "Video",
                "url": this.videoUrl,
                "position": cartesian,
                "cameraPosition": cameraPosition,
                "fov": this.fov,
                "aspectRatio": this.aspect,
                "alpha": this.alpha,
                "debugFrustum": this.debugFrustum,
                "heading": 0
                // "dirObj": {
                //     "direction": { "x": 0.07331987934745406, "y": -0.31686588753316797, "z": -0.9456321719412325 },
                //     "right": { "x": 0.8826585211077188, "y": 0.46201009007723565, "z": -0.08637483304041443 },
                //     "up": { "x": -0.4642608430704491, "y": 0.8283373020603265, "z": -0.3135588997412374 }
                // }
            };
            selectedView = new video3D(viewer, Cesium, params);

            selectedView.videoPlay = true;
            selectedView.show = true;
            selectedView.locate();

            // viewer.camera.flyTo({
            //     destination: cameraPosition
            // });
        },
        change_position() {
            if (!selectedView) return;
            pickUti.listen((cartesian) => {
                //this.ruleForm.lon = cartesian2lonlat(cartesian);
                pickUti.clear();
                selectedView.position = cartesian;
            });
        },
        change_cameraPosition() {
            if (!selectedView) return;
            pickUti.listen((cartesian) => {
                //this.ruleForm.lon = cartesian2lonlat(cartesian);
                pickUti.clear();
                selectedView.cameraPosition = cartesian;
            });
        },
        change_fov() {
            if (selectedView) {
                selectedView.fov = this.ruleForm.fov;
                console.log(selectedView.params)
            }
        },
        change_aspect() {
            if (selectedView) {
                selectedView.aspectRatio = this.ruleForm.aspect;
                console.log(selectedView.params)
            }
        },
        change_alpha() {
            if (selectedView) {
                selectedView.alpha = this.ruleForm.alpha;
                console.log(selectedView.params)
            }
        },
        change_heading() {
            if (selectedView) {
                selectedView.heading = this.ruleForm.heading;
                console.log(selectedView.params)
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.form-bottom {
    text-align: center;
}
</style>